import { Group, Image, Link, Select, Style, TextArea, TextInput, Checkbox } from '@makeswift/runtime/controls';

import { MsMainBanner } from '~/lib/makeswift/components/main-banner/client';
import { runtime } from '~/lib/makeswift/runtime';

runtime.registerComponent(MsMainBanner, {
  type: 'main-banner',
  label: 'Canary / Main Banner',
  builtinSuspense: false,
  props: {
    className: Style({ properties: [Style.Width, Style.Margin] }),
    variant: Select({
      label: 'Variant',
      labelOrientation: 'horizontal',
      options: [
        { value: 'large', label: 'Large' },
        { value: 'medium', label: 'Medium' },
      ],
      defaultValue: 'large',
    }),
    fetchPriority: Checkbox({ label: 'Is on top of the page', defaultValue: false }),
    cta: Group({
      label: 'Button',
      props: {
        link: Link({ label: 'Link' }),
        linkText: TextInput({
          label: 'Link Text',
          defaultValue: 'Shop Now',
        }),
      },
    }),
    background: Group({
      label: 'Background',
      props: {
        image: Image(),
        alt: TextInput({
          label: 'Image Alt',
          defaultValue: '',
        }),
      },
    }),
    content: Group({
      label: 'Content',
      props: {
        heading: TextInput({
          label: 'Heading Text',
          defaultValue: 'Heading Text',
        }),
        description: TextArea({ label: 'Short Description' }),
      },
    }),
  },
});
